import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './SlideRNDGallery.css';

const rndItems = [
  { id: 'rnd-03', src: '/images/gallery/gallery-03.jpg', alt: 'R&D Gallery 03' },
  { id: 'rnd-04', src: '/images/gallery/gallery-04.jpg', alt: 'R&D Gallery 04' },
  { id: 'rnd-05', src: '/images/gallery/gallery-05.jpg', alt: 'R&D Gallery 05' },
  { id: 'rnd-office-02', src: '/images/rnd/office2.png', alt: 'R&D Office 02' },
  { id: 'rnd-office-03', src: '/images/rnd/office3.png', alt: 'R&D Office 03' },
  { id: 'rnd-office-04', src: '/images/rnd/office4.png', alt: 'R&D Office 04' },
  { id: 'rnd-office-06', src: '/images/rnd/office6.png', alt: 'R&D Office 06' },
  { id: 'rnd-office-08', src: '/images/rnd/office8.png', alt: 'R&D Office 08' },
  { id: 'rnd-office-09', src: '/images/rnd/office9.png', alt: 'R&D Office 09' },
];

function SlideRNDGallery() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const [activeItem, setActiveItem] = useState<null | (typeof rndItems)[number]>(null);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    if (!activeItem) return;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setActiveItem(null);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [activeItem]);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 18 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-rnd-gallery">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="rndg-bg">
        <div className="rndg-grid-bg" />
        <div className="rndg-glow rndg-glow-left" />
        <div className="rndg-glow rndg-glow-right" />
        <div className="rndg-noise" />
      </div>

      <div className="rndg-content">
        <motion.div className="rndg-header" {...fadeUp(0.05)}>
          <span className="rndg-eyebrow">R&amp;D DEPARTMENT</span>
          <h1 className="rndg-title">R&amp;D GALLERY</h1>
        </motion.div>

        <div className="rndg-grid">
          {rndItems.map((item, index) => (
            <motion.button
              key={item.id}
              className={`rndg-item rndg-item--${item.id}`}
              type="button"
              onClick={() => setActiveItem(item)}
              aria-label={`Open R&D image ${index + 1}`}
              {...fadeUp(0.12 + index * 0.07)}
            >
              <img src={item.src} alt={item.alt} loading="lazy" />
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {activeItem && (
          <motion.div
            className="rndg-modal"
            role="dialog"
            aria-modal="true"
            aria-label={activeItem.alt}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: reduceMotion ? 0 : 0.25 }}
            onClick={() => setActiveItem(null)}
          >
            <motion.div
              className="rndg-modal-card"
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: reduceMotion ? 0 : 0.25 }}
              onClick={(e) => e.stopPropagation()}
            >
              <img src={activeItem.src} alt={activeItem.alt} />
              <button
                type="button"
                className="rndg-modal-close"
                onClick={() => setActiveItem(null)}
                aria-label="Close image"
              >
                ×
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default SlideRNDGallery;
